/* pw-effects.js — motion-anything (Apache-2.0, nexu-io) recipes, brand-adapted.
   Wave 1: sheen (shiny-text), glare (glare-hover), spotlight (spotlight-card),
   beam (border-beam). Wave 2: ripple-press, shimmer-button, tilt-3d, star-border.
   Progressive enhancement only; never throws. Ripple works on touch (press
   feedback); pointer effects are desktop-only; everything is static under
   prefers-reduced-motion. Never animates layout. */
(function () {
  'use strict';
  var mq = window.matchMedia || function () { return { matches: false }; };
  var REDUCED = mq('(prefers-reduced-motion: reduce)').matches;
  var TOUCH = mq('(hover: none)').matches;

  function track(el, xVar, yVar) {
    if (el.__pwTracked) return;
    el.__pwTracked = true;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty(xVar, (e.clientX - r.left) + 'px');
      el.style.setProperty(yVar, (e.clientY - r.top) + 'px');
    });
  }

  /* ripple-press: wave blooms at the exact press point */
  function attachRipple(el) {
    if (!el || el.__pwRipple) return;
    el.__pwRipple = true;
    el.classList.add('pw-ripple');
    el.addEventListener('pointerdown', function (e) {
      if (REDUCED) return;
      try {
        var r = el.getBoundingClientRect();
        var size = Math.max(r.width, r.height) * 2;
        var x = (e.clientX != null ? e.clientX : r.left + r.width / 2) - r.left;
        var y = (e.clientY != null ? e.clientY : r.top + r.height / 2) - r.top;
        var w = document.createElement('span');
        w.className = 'pw-ripple-wave';
        w.style.width = w.style.height = size + 'px';
        w.style.left = (x - size / 2) + 'px';
        w.style.top = (y - size / 2) + 'px';
        el.appendChild(w);
        w.addEventListener('animationend', function () {
          if (w.parentNode) w.parentNode.removeChild(w);
        });
      } catch (err) { /* silent */ }
    });
  }

  /* tilt-3d: small pointer-mapped rotation on outlet photos */
  function attachTilt(el) {
    if (!el || el.__pwTilt) return;
    el.__pwTilt = true;
    var max = parseFloat(el.getAttribute('data-pw-tilt-max')) || 6;
    el.addEventListener('pointermove', function (e) {
      try {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--pw-ry', (((e.clientX - r.left) / r.width - 0.5) * 2 * max).toFixed(2) + 'deg');
        el.style.setProperty('--pw-rx', ((0.5 - (e.clientY - r.top) / r.height) * 2 * max).toFixed(2) + 'deg');
      } catch (err) { /* silent */ }
    });
    el.addEventListener('pointerleave', function () {
      el.style.setProperty('--pw-rx', '0deg');
      el.style.setProperty('--pw-ry', '0deg');
    });
  }

  function augment() {
    try {
      var i, els, el;
      // press feedback on every action control (touch included)
      els = document.querySelectorAll('.pw-button, .btn-theme, .pw-actions a');
      for (i = 0; i < els.length; i++) attachRipple(els[i]);
      if (REDUCED) return;
      // ambient CSS classes (not pointer-based; fine on touch)
      el = document.querySelector('.pw-hero .pw-actions .pw-button') || document.querySelector('.pw-actions .pw-button');
      if (el) el.classList.add('pw-shimmer');
      el = document.querySelector('.pw-enquiry-band .pw-actions .pw-button');
      if (el) el.classList.add('pw-star');
      if (TOUCH) return;
      // wave 1: sheen on the hero editorial tagline
      els = document.querySelectorAll('.pw-hero-editorial > p');
      for (i = 0; i < els.length; i++) els[i].classList.add('pw-shiny');
      // beam on the hero editorial frame
      els = document.querySelectorAll('.pw-hero-editorial');
      for (i = 0; i < els.length; i++) els[i].classList.add('pw-beam');
      // glare on card media (home + collection grids)
      els = document.querySelectorAll('.pw-watch-image, .product-card__image-wr');
      for (i = 0; i < els.length; i++) { els[i].classList.add('pw-glare'); track(els[i], '--pw-gx', '--pw-gy'); }
      // spotlight on cards
      els = document.querySelectorAll('.pw-watch-card, .product-card');
      for (i = 0; i < els.length; i++) { els[i].classList.add('pw-spotlight'); track(els[i], '--pw-mx', '--pw-my'); }
      // wave 2: tilt on hero editorial panel + outlet photos (auto-activates
      // when storefront images are configured) + explicit data-pw-tilt targets
      els = document.querySelectorAll('.pw-hero-editorial, .pw-outlet-photos figure, [data-pw-tilt]');
      for (i = 0; i < els.length; i++) attachTilt(els[i]);
    } catch (e) { /* leave page untouched */ }
  }

  if (document.readyState !== 'loading') augment();
  else document.addEventListener('DOMContentLoaded', augment);

  // theme editor / dynamic sections re-render DOM
  document.addEventListener('shopify:section:load', function () { setTimeout(augment, 60); });
})();
